var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9358_76657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25496 0.458998C3.79431 0.524903 2.52829 0.882014 1.50601 1.89998C0.480161 2.92329 0.127485 4.19432 0.0614165 5.63978C0.0203465 6.54197 -0.219809 13.3578 0.476591 15.1453C0.946214 16.3511 1.87115 17.2783 3.08807 17.7494C3.6559 17.9703 4.30411 18.1198 5.25496 18.1635C13.2055 18.5233 16.1527 18.3274 17.3955 15.1453C17.616 14.5788 17.7678 13.9312 17.8098 12.9827C18.1732 5.01174 17.7509 3.28398 16.3652 1.89998C15.2662 0.803638 13.9733 0.0573347 5.25496 0.458998ZM5.32815 16.5604C4.45765 16.5212 3.98536 16.3761 3.67019 16.2541C2.87737 15.946 2.28186 15.3529 1.97562 14.5647C1.44529 13.2066 1.62118 6.75587 1.6685 5.71207C1.71493 4.68965 1.92206 3.75522 2.64346 3.03384C3.53628 2.14322 4.68979 1.70674 12.5439 2.06121C13.5689 2.10752 14.5055 2.31422 15.2287 3.03384C16.1215 3.92444 16.5643 5.08683 16.2036 12.9108C16.1643 13.7792 16.0188 14.2504 15.8965 14.5647C15.0885 16.6354 13.2296 16.9229 5.32815 16.5604ZM12.6305 4.55674C12.6305 5.14633 13.11 5.62576 13.7019 5.62576C14.2939 5.62576 14.7742 5.14633 14.7742 4.55674C14.7742 3.96716 14.2939 3.48817 13.7019 3.48817C13.11 3.48817 12.6305 3.96716 12.6305 4.55674ZM4.35142 9.3108C4.35142 11.8366 6.40402 13.8843 8.93605 13.8843C11.4681 13.8843 13.5207 11.8366 13.5207 9.3108C13.5207 6.78503 11.4681 4.73856 8.93605 4.73856C6.40402 4.73856 4.35142 6.78503 4.35142 9.3108ZM5.96028 9.3108C5.96028 7.67208 7.29237 6.34253 8.93605 6.34253C10.5797 6.34253 11.9118 7.67208 11.9118 9.3108C11.9118 10.9504 10.5797 12.2804 8.93605 12.2804C7.29237 12.2804 5.96028 10.9504 5.96028 9.3108Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9358_76657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9454,
    height: 17.9454,
    fill: "white",
    transform: "translate(0 0.350098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.1b988308.svg";
export { ForwardRef as ReactComponent };